﻿<template>
    <div v-for="toast in toastInit">
        <!--讓summary/detail都有自己的css格式(primevue v3.6)-->
        <!--zIndex.modal:1100, 避免Dialog使用Toast時被遮-->
        <Toast :position="toast.position as any" :group="toast.group">
            <template #message="slotProps">
                <div class="flex flex-column py-2"
                     style="width: auto; max-width: 500px; min-width: 250px;">

                    <div class="p-toast-summary"
                         style="font-size: 1rem; font-weight: bold; white-space: nowrap;"
                         v-if="slotProps.message.summary"
                         v-html="slotProps.message.summary">
                    </div>

                    <div class="p-toast-detail"
                         style="font-size: 1rem; margin-top: 0.5rem; word-break: break-all;"
                         v-html="slotProps.message.detail">
                    </div>
                </div>
            </template>
        </Toast>
    </div>
</template>

<style scoped>
    /* 背景不透明 */
    ::v-global(.p-toast-message-content) {
        background-color: var(--p-surface-ground) !important;
    }
</style>

<script lang="ts">
    //normal <script> executed in module scope (only once)
    //只會執行一次(第1次) 除非按下F5

    export default {
        name: module$.toaster,
        inheritAttrs: false
    }
</script>

<script setup lang="ts">
    import { reactive } from 'vue'
    import { module$ } from '../enums'

    //***************工具物件***************

    //***************屬性/計算**************
    //toast初始
    const toastInit = reactive([
        { position: 'top-right', group: 'tr' },
        { position: 'bottom-right', group: 'br' },
        { position: 'top-center', group: 'tc' },
        { position: 'center', group: 'c' },
        { position: 'bottom-center', group: 'bc' },
        { position: 'top-left', group: 'tl' },
        { position: 'bottom-left', group: 'bl' }
    ]);

    //***************元件函式**************

    //***************元件監看**************

    //***************元件鉤子**************

</script>